/**
 * User Token CrossFrame Listeners
 *
 * Handles CrossFrame requests for user authentication and store scan operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetAssociateRecordInput, GetAssociateRecordOutput, GetScanStatusInput, GetScanStatusOutput } from '@amzn/coral_com-amazon-ihmharmonyservice'
import { store } from '@atredux/store'
import { setStoreScanStatus, setSelectedStoreId } from '@atredux/slices/storeSlice'
import { setCurrentStore } from '@services/StoreService'
import { validateRequired } from './listenerUtils'

/**
 * Retrieves associate record for associate entry.
 */
export async function getAssociateRecordListener (message: any): Promise<GetAssociateRecordOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'appType', 'associateId', 'storeId')
    const client = getServiceClient()
    return client.getAssociateRecord(GetAssociateRecordInput.clone(params)).toPromise()
}

/**
 * Gets scan status for a recognition token.
 */
export async function getScanStatusListener (message: any): Promise<GetScanStatusOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'recognitionToken')
    const client = getServiceClient()
    return client.getScanStatus(GetScanStatusInput.clone(params)).toPromise()
}

/**
 * Handles scan completion notification.
 * Updates Redux store to mark store as scanned, sets it as current store, and clears the selected store ID.
 */
export async function notifyScanCompleteListener (message: any): Promise<void> {
    console.log('SMP: Received notifyScanComplete request')
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId', 'recognitionToken')

    console.log(`SMP: Updating store context to ${params.storeId}`)

    // Mark store as scanned
    store.dispatch(setStoreScanStatus({ storeId: params.storeId, scanned: true }))
    // Set current store (fetches store info and updates Redux)
    await setCurrentStore(params.storeId)
    // Clear selected store since it's now current
    store.dispatch(setSelectedStoreId(undefined))

    console.log('SMP: Store context updated successfully')
}
